import overlay from "./overlay";
import wait from "../helpers/wait";
import { isDesktop } from "../helpers/utilities";

interface ISearchBarConfig {
  selectors: ISearchBarSelectors,
  htmlElements: ISearchBarHTMLElements
}

interface ISearchBarSelectors {
  searchBar: string,
  open: string,
  input: string,
  close: string
}

interface ISearchBarHTMLElements {
  searchBar: HTMLElement,
  open: HTMLElement,
  input: HTMLElement,
  close: HTMLElement
}

class SearchBar {

  private config: ISearchBarConfig;

  constructor() {
    this.config = {
      htmlElements: {
        searchBar: null,
        open: null,
        input: null,
        close: null
      },
      selectors: {
        searchBar: '[data-search-bar]',
        open: '[data-search-bar-open]',
        close: '.snize-close-button',
        input: '[data-search-bar-input]'
      }
    }
  }

  init() {
    this.config.htmlElements.searchBar = document.querySelector(this.config.selectors.searchBar);
    this.config.htmlElements.open = document.querySelector(this.config.selectors.open);
    this.config.htmlElements.input = document.querySelector(this.config.selectors.input);
    this.addEventListeners();
  }

  addEventListeners() {
    if (isDesktop()) {
      this.config.htmlElements.open.addEventListener('click', this.handleSearchBarOpenClick.bind(this));
    } else {
      this.config.htmlElements.input.addEventListener('click', this.handleSearchBarInputMobileClick.bind(this));
      this.config.htmlElements.input.addEventListener('touchstart', this.handleSearchBarInputMobileClick.bind(this));
    }
  }

  async handleSearchBarInputMobileClick() {
    this.config.htmlElements.close = await wait.forHTMLElement(this.config.selectors.close, 100, 10);
    if (this.config.htmlElements.close) this.config.htmlElements.close.addEventListener('click', this.handleSearchBarCloseClick.bind(this));
    document.body.classList.add('no-scroll');
  }

  handleSearchBarOpenClick() {
    this.config.htmlElements.searchBar.classList.toggle('hide--md-up');
  }

  handleSearchBarCloseClick() {
    document.body.classList.remove('no-scroll');
  }
}

export default new SearchBar();